import React from "react";
import keycloak from "../keycloak";
import { useAuthStatus } from "./AuthStatus";
import { hydrateLocaleFromProfile } from "./profileLocale";

/** US-1001: after SSO, hydrate i18n from server profile.locale. */
export function ProfileLocaleSync() {
  const { authReady } = useAuthStatus();

  React.useEffect(() => {
    if (!authReady || !keycloak.authenticated) {
      return;
    }
    void hydrateLocaleFromProfile();
  }, [authReady]);

  return null;
}
